module.exports = __webpack_public_path__ + "static/media/full_11.42860056.jpg";